import { AiTaskStatus } from '@com/components/text-to-audio/enums'
import { queryTask } from '@pt/api/common'
import numeral from 'numeral'
import { downloadLoadDocument } from '@/common/download.js'
import { Message } from 'element-ui'
import i18n from '@/lang'
import { getFileExtension, getFileName } from '@com/utils/file'
import { rateMetrics, timeMetrics, moneyMetrics } from './config'
import { isFunction } from 'lodash-es'
import { Metrics, PlaceAdsMetrics } from '@pt/enums/insights'

// 传入百分比（0~1 NaN Infinity) 返回百分比字符串
export function percent(value: number): string {
  if (isNaN(value) || !isFinite(value)) {
    return '0%'
  }
  return numeral(value).format('0.00%')
}

// 毫秒转秒
export function msToS(ms: number): string {
  return (ms / 1000).toFixed(0)
}

export function formatDollar(v: number): string {
  return numeral(v).format('$0,0[.]00')
}

export function formatMetricsValue(
  value: number,
  metrics: typeof rateMetrics[0] | typeof timeMetrics[0],
  options?: {
    numeralFormat?: boolean | ((v: number) => string)
  },
): string | number {
  const { numeralFormat = true } = options ?? {}
  if (timeMetrics.includes(metrics)) {
    return `${Math.round(value / 1000)}s`
  } else if (rateMetrics.includes(metrics)) {
    // 点击率、转化率、展示转化率，超过100%的时候可以展示为-
    const unshowValue =
      [PlaceAdsMetrics.ctr, PlaceAdsMetrics.cvr, PlaceAdsMetrics.ivr].includes(
        metrics as any,
      ) && value > 1
    return unshowValue ? '-' : percent(value)
  } else if (moneyMetrics.includes(metrics)) {
    return formatDollar(value)
  } else if ([Metrics.vi_avg].includes(metrics as any)) {
    return value.toFixed(2)
  }

  if (!numeralFormat) {
    return value
  }

  if (isFunction(numeralFormat)) {
    return numeralFormat(value)
  }

  return numeral(value).format('0,0')
}

// 创建自定义的格式化函数
export function customNumberFormat(value: number): string {
  const abbreviations = ['', 'k', 'm', 'bn', 'tn']
  const _tier = Math.floor(Math.log10(Math.abs(value)) / 3)
  const tier =
    _tier > abbreviations.length - 1 ? abbreviations.length - 1 : _tier
  const scaled = value / Math.pow(10, tier * 3)

  return `${numeral(scaled).format('0,0')}${abbreviations[tier] ?? ''}`
}
export async function waitExport(id: any): Promise<string> {
  // 定时3秒查询一次，根据返回的status判断是否完成
  return new Promise((resolve, reject) => {
    const query = () => {
      queryTask([id]).then((res) => {
        const data = res.data.data?.[0]

        if (!data) {
          reject()
        } else if (data.status === AiTaskStatus.Success) {
          resolve(data.result)
        } else if (data.status === AiTaskStatus.Failed) {
          reject()
        } else {
          setTimeout(() => {
            query()
          }, 3000)
        }
      })
    }

    query()
  })
}

export function exportAndDownload(id: any): ReturnType<typeof waitExport> {
  const task = waitExport(id)
  task
    .then((url) => {
      downloadLoadDocument(url, getFileName(url), getFileExtension(url))
    })
    .catch(() => {
      Message.error(i18n.t('playTurbo.dashboard.export.error').toString())
    })

  return task
}
